import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconOldJoystick: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOldJoystick"><Path d="M12 9V15.5" stroke="currentColor"/><Path d="M17.5 12V15.5" stroke="currentColor"/><Path d="M20.5 15.5H3.5V20.5H20.5V15.5Z" stroke="currentColor"/><Circle cx="12" cy="6.5" r="3" stroke="currentColor"/></CentralIconBase>;
});

export default IconOldJoystick;
